import styled from 'styled-components';
import { Button } from 'style/buttons';
import devices from 'style/breakpoints';
import colors from 'style/palette/palette';


export const Form = styled.form`

    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    flex-direction: column;
`;

export const UserInputsBox = styled.div`

    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    gap: 16px;
    flex-direction: column;
`;

export const LoginButton = styled(Button)`

    width: 100%;

    margin: 24px 0 0;
    padding: 15px 8px;

    font-size: 15px;
    text-transform: uppercase;

    color: ${colors.black087};

    @media ${devices.tablet} {

        padding: 15px 8px;
        letter-spacing: normal;
    }
`;
